import { VIEW_TYPES } from "@/other/constants/OtherKeys";
import {
  contextPageGuide,
  contextPageSetupGuide,
  CONTEXT_GUIDE_TARGETS,
} from "./definitions/contextPageGuide";
import {
  marketingManifestGuide,
  marketingManifestSetupGuide,
  MANIFEST_GUIDE_TARGETS,
} from "./definitions/marketingManifestGuide";
import {
  kanbanCardFieldsEditorGuide,
  kanbanCardFieldsEntryGuide,
  KANBAN_CARD_FIELDS_GUIDE_TARGETS,
} from "./definitions/kanbanCardFieldsGuide";
import { isGuideTargetPresent } from "./selectors";
import type { PageGuideDefinition, PageGuideResolver, ViewType } from "./types";

const pageGuideRegistry: Partial<Record<ViewType, PageGuideResolver>> = {};

export function registerPageGuide(viewType: ViewType, resolver: PageGuideResolver): void {
  pageGuideRegistry[viewType] = resolver;
}

export function resolvePageGuide(viewType: ViewType): PageGuideDefinition | null {
  const resolver = pageGuideRegistry[viewType];
  return resolver ? resolver() : null;
}

function resolveKanbanCardFieldsGuide(viewType: ViewType): PageGuideDefinition | null {
  if (isGuideTargetPresent(KANBAN_CARD_FIELDS_GUIDE_TARGETS.visibleSection)) {
    return { ...kanbanCardFieldsEditorGuide, viewType };
  }
  if (isGuideTargetPresent(KANBAN_CARD_FIELDS_GUIDE_TARGETS.openButton)) {
    return { ...kanbanCardFieldsEntryGuide, viewType };
  }
  return null;
}

/** Register all page guides here when adding a new view tour. */
registerPageGuide(VIEW_TYPES.context, () =>
  isGuideTargetPresent(CONTEXT_GUIDE_TARGETS.contextDetail)
    ? contextPageGuide
    : contextPageSetupGuide,
);

registerPageGuide(VIEW_TYPES.marketingManifest, () =>
  isGuideTargetPresent(MANIFEST_GUIDE_TARGETS.manifestBody)
    ? marketingManifestGuide
    : marketingManifestSetupGuide,
);

for (const viewType of [VIEW_TYPES.tasks, VIEW_TYPES.resources, VIEW_TYPES.clients] as const) {
  registerPageGuide(viewType, () => resolveKanbanCardFieldsGuide(viewType));
}
